import ResendInviteUserToOrgObject from "api/lib/data/interfaces/ResendInviteUserToOrgObject";
import UserChangeAccountTypeObject from "api/lib/data/interfaces/UserChangeAccountTypeObject";
import Organizations from "api/lib/data/Organizations";
import * as _ from "lodash";
import * as React from "react";
import { toast } from "react-semantic-toasts";
import {
  Button,
  Form,
  Icon,
  Input,
  Item,
  List,
  Modal,
  Popup,
  Radio,
  Segment,
  Table,
} from "semantic-ui-react";
import {
  IBaseProps,
  Base,
  IBaseState,
  Event,
} from "src/components/Common/Base";
import { InviteUserModel } from "src/components/Organizations/InviteUsersModel";
import { cloneWithOutReference } from "src/utils";
export interface IManageUsersProps extends IBaseProps {
  history: any;
}

export interface IManageUsersState extends IBaseState {
  user: any;
  orgId: string;
  column: string;
  data: any[];
  filteredData: any[];
  invitedUsersData: any[];
  filteredInvitedUsersData: any[];
  direction?: "ascending" | "descending";
  openInviteUserModel: boolean;
  openChangeAccountTypeModal: boolean;
  selectedUser: any;
}
export default class ManageUsersTable extends Base<
  IManageUsersProps,
  IManageUsersState
> {
  private static INITAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    column: "",
    data: [],
    filteredData: [],
    invitedUsersData: [],
    filteredInvitedUsersData: [],
    direction: undefined,
    listeners: [],
    orgId: "",
    user: null,
    openInviteUserModel: false,
    openChangeAccountTypeModal: false,
    selectedUser: {},
  };

  private radioGroupRef = null;

  constructor(props: IManageUsersProps) {
    super(props);

    this.state = { ...ManageUsersTable.INITAL_STATE };
    this.radioGroupRef = React.createRef();
  }

  public render() {
    const {
      column,
      filteredData,
      filteredInvitedUsersData,
      direction,
      openInviteUserModel,
      openChangeAccountTypeModal,
      selectedUser,
    } = this.state;

    return (
      <Segment className="datasources_segment_main">
        <div style={{ padding: "5px 0", height: "50px" }}>
          <div style={{ float: "left" }}>
            <Input
              icon="search"
              iconPosition="left"
              name="search"
              onClick={(e: React.BaseSyntheticEvent) => e.stopPropagation()}
              onChange={this.handleSearchInputChange}
              placeholder={`Search Users`}
              style={{ width: "100%", padding: "0" }}
            />
          </div>
          <div style={{ float: "right" }}>
            <InviteUserModel
              authUser={this.props.authUser}
              currentOrg={{
                id: this.props.orgId,
                name: this.props.orgConfig.name,
              }}
              open={openInviteUserModel}
              setOpen={() => {
                this.setState({ openInviteUserModel: false });
              }}
            />
            <Button
              floated="right"
              primary={true}
              positive={true}
              onClick={() => {
                this.setState({ openInviteUserModel: true });
              }}
            >
              Invite People
            </Button>
          </div>
        </div>

        <Table
          sortable={true}
          celled={true}
          fixed={true}
          striped={true}
          compact="very"
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={column === "name" ? direction : undefined}
                onClick={this.handleSort("name")}
              >
                Name
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={column === "type" ? direction : undefined}
                onClick={this.handleSort("type")}
              >
                Type
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={column === "id" ? direction : undefined}
                onClick={this.handleSort("id")}
              >
                Actions
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(filteredData, (d) => this.renderTableRow(d))}
            {_.map(filteredInvitedUsersData, (d) => this.renderTableRow(d))}
          </Table.Body>
        </Table>
        <Modal
          size="tiny"
          open={openChangeAccountTypeModal}
          onClose={() => this.setState({ openChangeAccountTypeModal: false })}
        >
          <Modal.Header>Change {selectedUser.name} Account Type</Modal.Header>
          <Modal.Content>
            <p>
              Choose what account type {selectedUser.name} will have in this
              organization
            </p>
            <Form>
              <Form.Field>
                <Radio
                  ref={this.radioGroupRef}
                  label="Owner"
                  name="radioGroup"
                  value="owner"
                  checked={selectedUser.newAccountType === "owner"}
                  onChange={this.handleNewAccountTypeChange}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  label="Admin"
                  name="radioGroup"
                  value="admin"
                  checked={selectedUser.newAccountType === "admin"}
                  onChange={this.handleNewAccountTypeChange}
                />
              </Form.Field>
              <Form.Field>
                <Radio
                  label="Member"
                  name="radioGroup"
                  value="member"
                  checked={selectedUser.newAccountType === "member"}
                  onChange={this.handleNewAccountTypeChange}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              negative={true}
              onClick={() =>
                this.setState({ openChangeAccountTypeModal: false })
              }
            >
              Cancel
            </Button>
            <Button
              positive={true}
              disabled={selectedUser.newAccountType === selectedUser.type}
              onClick={this.requestChangeAccountType}
            >
              Save
            </Button>
          </Modal.Actions>
        </Modal>
      </Segment>
    );
  }
  public componentDidMount = () => {
    this.getData();
  };

  private getData = () => {
    const { orgId } = this.props;
    const orgs = new Organizations();
    this.getMembers((data) => {
      this.setState({ data });
      this.setState({ filteredData: data });
    });
    this.getListner(
      orgs.getUnRegisteredMembers(orgId),
      Event.Value,
      (snapshot: firebase.database.DataSnapshot) => {
        const dataObj = snapshot.val();
        if (dataObj) {
          const invitedUsersData = Object.keys(dataObj).map((id) => {
            const member = dataObj[id];
            return {
              id,
              name: member.email.split("@")[0],
              email: member.email,
              type: "Invited Member",
            };
          });
          this.setState({ invitedUsersData });
          this.setState({ filteredInvitedUsersData: invitedUsersData });
        } else {
          this.setState({ invitedUsersData: [] });
          this.setState({ filteredInvitedUsersData: [] });
        }
      }
    );
  };

  private handleSearchInputChange = (
    e: React.SyntheticEvent,
    { value }: any
  ) => {
    const data = cloneWithOutReference(this.state.data);
    const invitedUsersData = cloneWithOutReference(this.state.invitedUsersData);
    if (value) {
      const filteredData = _.filter(data, (o) =>
        _.toLower(o.name).includes(_.toLower(value))
      );
      const filteredInvitedUsersData = _.filter(invitedUsersData, (o) =>
        _.toLower(o.name).includes(_.toLower(value))
      );
      this.setState({ filteredData, filteredInvitedUsersData });
    } else {
      this.setState({ filteredData: data });
    }
  };

  private handleSort = (clickedColumn: string) => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending",
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  };

  private renderTableRow = ({ id, name, email, type }) => {
    return (
      <Table.Row key={name}>
        <Table.Cell>
          <Item>
            <Item.Content>
              <Item.Header as="h3">{name}</Item.Header>
              <Item.Extra>{email}</Item.Extra>
            </Item.Content>
          </Item>
        </Table.Cell>
        <Table.Cell>{type}</Table.Cell>
        <Table.Cell>
          {id !== this.props.authUser.uid && (
            <Popup
              style={{ padding: "0" }}
              trigger={<Icon link={true} name="ellipsis vertical" />}
              position="bottom left"
              on="click"
            >
              <List divided={true} relaxed={true} selection={true}>
                {type !== "Invited Member" && (
                  <List.Item
                    as="a"
                    onClick={() => {
                      this.handleChangeAccountType(id, name, type);
                    }}
                  >
                    <List.Content>
                      <List.Header>Change account type</List.Header>
                    </List.Content>
                  </List.Item>
                )}
                {type !== "Invited Member" && (
                  <List.Item
                    as="a"
                    onClick={() => {
                      this.handleDeactivateAccount(id);
                    }}
                  >
                    <List.Content>
                      <List.Header>De activate Account</List.Header>
                    </List.Content>
                  </List.Item>
                )}
                {type === "Invited Member" && (
                  <List.Item
                    as="a"
                    onClick={() => {
                      this.handleResendInvite(email);
                    }}
                  >
                    <List.Content>
                      <List.Header>Resend Invitation</List.Header>
                    </List.Content>
                  </List.Item>
                )}
                {type === "Invited Member" && (
                  <List.Item
                    as="a"
                    onClick={() => {
                      this.handleRevokeInvite(email);
                    }}
                  >
                    <List.Content>
                      <List.Header>Revoke Invitation</List.Header>
                    </List.Content>
                  </List.Item>
                )}
              </List>
            </Popup>
          )}
        </Table.Cell>
      </Table.Row>
    );
  };

  private handleChangeAccountType = (
    id: string,
    name: string,
    type: string
  ) => {
    this.setState(
      {
        selectedUser: { id, name, type, newAccountType: type },
        openChangeAccountTypeModal: true,
      },
      () => {
        if (this.radioGroupRef && this.radioGroupRef.current) {
          this.radioGroupRef.current.focus();
        }
      }
    );
  };

  private handleNewAccountTypeChange = (e, { value }) => {
    const selectedUser = this.state.selectedUser;
    selectedUser.newAccountType = value;
    this.setState({ selectedUser });
  };

  private requestChangeAccountType = () => {
    const { orgId, authUser } = this.props;
    const { id, newAccountType } = this.state.selectedUser;
    const org = new Organizations();
    const inviteUserReq: UserChangeAccountTypeObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        userId: id,
        newAccountType,
      },
    };
    org
      .requestChangeAccountType(orgId, authUser.uid, inviteUserReq)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          org.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              if (resp.headers.statusCode === 200) {
                toast({
                  type: "success",
                  icon: "info circle",
                  title: `Account type changed successfully `,
                  animation: "slide up",
                  time: 5000,
                });
                this.getMembers((data) => {
                  this.setState({ data });
                });
                this.setState({ openChangeAccountTypeModal: false });
              } else {
                toast({
                  type: "error",
                  icon: "info circle",
                  title: `Account type change failed: ${resp.headers.msg}`,
                  animation: "slide up",
                  time: 5000,
                });
                this.setState({ openChangeAccountTypeModal: false });
              }
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  private handleDeactivateAccount = (userId: string) => {
    const { orgId, authUser } = this.props;
    const org = new Organizations();
    const inviteUserReq: UserChangeAccountTypeObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        userId,
      },
    };
    org
      .requestDeActivateUser(orgId, authUser.uid, inviteUserReq)
      .then(() => {
        this.getMembers((data) => {
          this.setState({ data });
        });
        toast({
          type: "success",
          icon: "info circle",
          title: `Invitation(s) sent successfully `,
          animation: "slide up",
          time: 5000,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  private handleResendInvite = (email: string) => {
    const { orgId, authUser } = this.props;
    const org = new Organizations();
    const inviteUserReq: ResendInviteUserToOrgObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        email,
      },
    };
    org
      .resendInvite(orgId, authUser.uid, inviteUserReq)
      .then(() => {
        toast({
          type: "success",
          icon: "info circle",
          title: `Invitation(s) sent successfully `,
          animation: "slide up",
          time: 5000,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  private handleRevokeInvite = (email: string) => {
    const { orgId, authUser } = this.props;
    const org = new Organizations();
    const inviteUserReq: ResendInviteUserToOrgObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        email,
      },
    };
    org
      .revokeInvite(orgId, authUser.uid, inviteUserReq)
      .then(() => {
        toast({
          type: "success",
          icon: "info circle",
          title: `Invitation(s) sent successfully `,
          animation: "slide up",
          time: 5000,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/containers/ManageUsers/ManageUsersTable.tsx